import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {PaymentsListHeader} from './components/header/PaymentsListHeader'
import {PaymentsTable} from './table/PaymentsTable'
import { PaymentEditModal } from './Payment-edit-modal/PaymentEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const PaymentsList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <PaymentsListHeader />
        <PaymentsTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <PaymentEditModal />}
    </>
  )
}

const PaymentsListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <PaymentsList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {PaymentsListWrapper}
